import React from 'react';

import UIStrings from '@/Utils/UIStrings';

import ScoreDetailsHeader from '../Components/Common/ScoreDetailsHeader';
import EICharacteristicsPanel from './Components/Characteristics/EICharacteristicsPanel';

function EmotionalIntelligenceScoreDetails(): React.JSX.Element {
    return (
        <div className="border-border bg-card rounded-xl border p-5">
            <ScoreDetailsHeader description={UIStrings.EmotionalIntelligenceScoreDetailsHeader} />
            <EICharacteristicsPanel />
        </div>
    );
}

export default EmotionalIntelligenceScoreDetails;
